import zhLocale from "element-ui/lib/locale/lang/zh-TW";
const zh = {
  //module.exports
  ...zhLocale,
  home: {
    username: "用戶名",
    password: "密碼",
    programmeHighlight: "暢銷課程",
    programme: "課程",
    showMore: "更多",
    grades: "年級",
    slogan0: "自信探索數學世界",
    slogan1: "享受理解成長樂趣",
    describe1: "MathConcept Online 與家長一同啟發孩子潛能",
    describe11: "在理解中建立邏輯自信，發現思考的快樂！",
    watch: "觀看影片",
    slogan2: "MathConcept Online 數學學習平台",
    describe2:
      "透過智能系統分析，精準評估學習弱項；以動畫將抽象的公式化身成生動故事，理解效率提升達 40%。匯聚逾十萬+題目，緊貼香港課程內容，涵蓋小一至小六。由資深教研團隊研發，緊貼學校進度，全程記錄學習歷程。讓孩子在探索中愛上數學，主動學習，自信成長！",
    slogan3: "快速提升小朋友數學能力，首選 MathConcept Online！",
    describe3:
      "融合趣味設計與專業教學。將抽象題目化身有趣動畫，解題效率提升達 3 倍！由基礎運算到思維邏輯，全方位覆蓋小學數學知識點，助孩子輕鬆掌握數學概念。專為香港學生度身設計，讓數學學習更有信心、更有動力！",
    banner1:
        "化身數學勇士闖關！結合香港小學課程設計難題，解鎖地圖與道具，在趣味挑戰中輕鬆掌握解題技巧！",
    banner2:
        "匯聚海量數學知識寶庫！全面覆蓋香港小學課程，經典題型與重點講解應有盡有，隨時重溫，鞏固知識，助孩子穩步提升數學實力！",
    describe4:
        "由小一的加減乘除到小六的幾何方程，全面掌握數學核心概念。透過「冒險模式」趣味闖關，建立解題邏輯；亦可選擇「圖書館模式」深度鞏固知識點，強化理解。覆蓋小學全階段課程，逐步培養數感與思維能力，助孩子自信應對各年級的數學挑戰！",
    process: "五步開啟數學高效學習之旅",
    describe5: "註冊個人帳戶 → 智能評估學習弱項 → 觀看動畫教學影片→ 大量數學題庫練習 → 階段測試驗收成果，讓進步清晰可見！",
    describe6: "與全港學生一齊學習，在趣味互動中突破自我。由打好基礎到挑戰難題，全面提升數學能力，建立真正自信！",
  },
  aboutUs: {
    title: "關於我們",
    aboutMathConcept: "關於 MathConcept",
    mathConceptDesc1: "MathConcept 由一群資深數學教學專家創辦，成員包括香港著名大學現職教育學系高級講師、暢銷中小學教科書作者、資深數學教師及教學管理專才，致力為 3 至 18 歲學生提供專業及全面的數學培訓。",
    mathConceptDesc2: "首家「MathConcept Learning Center」於奧海城開幕。目前 MathConcept 分校遍佈於全港多個地區，超過 20,000 名學生報讀。",
    mathConceptOnlineIdea: "MathConcept Online 的理念",
    onlineIdeaDesc1: "本校教學團隊投入大量資源，由零開始，撰寫教材，開發針對香港市場的營運及評估系統。時至今日，「MathConcept」擁有超過 10 萬張專業教材，岀版 104 本註冊書刊，滿足 3 至 18 歲的本地及國際學校學生的不同需要，致力培育每一個孩子。",
    onlineIdeaDesc2: "我們深信每個孩子皆擁有無限可能。本校教學團隊致力於啟發孩子的數學潛能，讓他們實現夢想。我們著重於培養正面學習態度，理解概念，接通思維以建立孩子對數學的信心及興趣，直接提升學生數學成績。",
  },
  onlineLearning: {
    desc: "平台以「線上結合實體」為核心，透過網上資源為面授課堂增值，提升學生學習體驗，同時讓家長清晰掌握課程成效，有效提升續報率，繼而穩定分校收生來源並拓展招生規模，突顯補習社的專業優勢。",
    heading1: "面授課 + 線上資源，開啟「融合式」高效學習",
    content1: "每堂面授課後配合教學影片，鞏固課堂知識；提供延伸練習及階段性測驗，家長可即時查閱學習數據，清楚見證孩子進步，進一步提升口碑與續報率。",
    heading2: "數據導向，制定個人化學習方案",
    content2: "老師透過平台實時掌握學生學習進度，結合數據分析，向家長提供針對性學習方向，協助學生提升數學實力！",
    heading3: "線上線下整合，打造無縫學習體驗",
    content3: "無需因缺課擔心進度落後！平台提供教學影片即時補足課堂內容；未來更將推動數據互通，作業可線上提交及批改，老師更準確掌握學習情況，全面提升學習效率。",
    heading4: "互動式教學影片，系統化數學知識內容",
    content4: "按年級及課題清晰分類（如：一年級進位加法），影片內設即時問答互動（如 Edpuzzle 模式），實時追蹤學習進度，助學生強化知識吸收與理解！",
    motto: "一切從理解開始！",
    modeDesc: "提供「冒險模式」及「圖書館模式」，迎合不同學習需要"
  },
  step:{
      step1Title: "步骤1",
    step1Content: "註冊",
      step2Title: "步骤2",
    step2Content: "評估",
      step3Title: "步骤3",
    step3Content: "觀看",
      step4Title: "步骤4",
    step4Content: "練習",
      step5Title: "步骤5",
    step5Content: "測驗",
  },
  contact:{
    desc: "如有任何查詢，請透過以下方式聯絡我們。",
  },
  programmeList: {
    allGrades: "全部 年級",
    allTopics: "全部 主題",
    allStars: "全部 成績",
    allStatus: "全部 狀態",
    sortBy: "排序",
  },
  dashboard: {
    dashboard: "儀錶盤",
    parentAccount: "父帳號",
    editAccount: "編輯帳號",
    deleteAccount: "刪除帳號",
    addAccount: "添加帳號",
    studentSummary: "學生總結",
    purchaseHistory: "購買歴史",
    studentAccount: "學生帳號",
    logOut: "登出",
  },
  programmeListDetail: {
    course: "課程",
    buyNow: "立即購買",
    type: "課程類型",
    addToCart: "添加到購物車",
    aboutThisCourse: "關於課程",
    aboutThisProgramme: "關於這個項目",
    trainingCompleted: "完成的培訓",
  },
  summaryOfArea: {
    summaryOfArea: "成績",
    myScore: "我的分數",
    backToHome: "返回主頁",
    checkTheCorrect: "檢查正確的",
    answerAtBelow: "答案在下面",
    practiceAgain: "再次練習!",
    unit: "單元",
    nextLesson: "下一個學習重點",
    completionLesson: "完成本課",
  },
  purchaseHistory: {
    purchaseHistory: "購買歴史",
    date: "日期",
    programme: "方案",
    assignedTo: "分配給",
    amount: "金額",
  },
  other: {
    sortBy: "排序方式",
    summaryOf: "的總結",
    programme: "課程",
    completion: "完成度",
    score: "分數",
    start: "試一試!",
    learnMore: "了解更多",
    about: "關於我們",
    platform: "網上學習平台",
    faq: "常見問題",
    help: "幫助手冊",
    contact: "聯絡我們",
    contactText: "如有任何査詢，請透過以下方式聯絡我們。",
    sitemap: "網頁指南",
    sitemapText: "MathConcept 跳转",
    home: "主頁",
    refund: "退款政策",
    privacy: "私隱政策聲明",
    disclaimer: "免責聲明",
    order: "訂閱",
    termsAndConditions: "條款和條件",
    version: "Mathconcept 數學思維有限公司。保留所有權利",
    login: "登入",
    register: "註冊家長帳戶",
    exit: "登出",
    next: "下一題",
    confirm: "確認",
    cancel: "取消",
    checkout: "結帳",
    total: "總計",
    topic: "主題",
    notStartedYet: "還未開始",
    assignTo: "分配給",
    cart: "購物車",
    cartWarning: "請選擇學生",
    programmeSuccess: "成功加入購物車",
    forgetPasswordSuccess: "發送郵件成功",
    orderError: "訂單錯誤",
    returnHome: "返回首頁",
    paymentFailure: "付款失敗",
    pleaseSelect: "請選擇",
    cartSummary: "購物車結帳",
    successful: "您購買成功",
    orderConfirmation: "訂單確認",
    termsCondition: "條款和條件",
  },
  account: {
    userName: "登錄名",
    displayName: "顯示名稱",
    gender: "性別",
    email: "電子郵件",
    oldPassword: "舊密碼",
    newPassword: "輸入新密碼",
    studentAccount: "學生帳戶名稱",
    studentName: "學生姓名",
    school: "學校",
    grade: "年級",
    renew: "續訂",
    addStudentAccount: "增加學生",
    editAccount: "編輯帳號",
    editChildAccount: "編輯學生資料",
    confirmPassword: "重複輸入新密碼",
    password: "密碼",
    passwordPlaceholder: "請輸入密碼",
    parentInformation: "父母信息",
    resetPassword: "重設密碼",
    birthday: "生日",
  },
  studentProgramme: {
    title: "我的課程",
    aboutCourse: "關於課程",
    lesson: "課程",
    startLearn: "開始學習",
    type: "課程類型",
    course: "課程",
    elaborate: "講解",
    practice: "測驗",
    answerRecord:"答題記錄",
    myFile:"我的檔案",
    courseSwitching:"課程切換",
    logOut: '登出',

    category: '範疇',
    partOne: 'I.數與運算',
    partTwo: 'II.圖形與測量',
    partThree: 'III.應用與思維',
    topic: '課題',

    startDate: "開始日期",
    endDate: "結束日期",
    finishDate: "完成時間",
    score: "分數",
    search: "搜尋",
    clearFilter: "清除篩選",
    searchForExamKeywords: "搜尋考試關鍵字",
    adventureMode:"冒險模式",
    libraryMode:"圖書館模式",
    homework:"作業",
    mode:"模式",
    topicTitle:"課题名稱",
    practiseName:"練習名稱",
    duration:"時長(分鐘)",
    scoreAndTotalScore:"得分/總分",
    review:"複習",
    accountName:"帳户名稱",
    subscriptionStatus:"訂閱狀態",
    myGrade:"我的年級",
    myGender:"我的性別",
    myBirthday:"我的生日",
    branchSchool:"我的分校",
    courseVersion:"課程版本",
    setPicture:"設定頭像",
    choosePicture:"請選擇一位角色做你的頭像。",
    update:"更新",
    switching:"切換",
    guide1:"先選擇想學習的範疇",
    guide2:"從範疇中選擇想學習的課題",
    guide3:"課題每部分均提供教學影片與練習題目，建議先觀看影片再開始練習，加強理解與應用",
    guide4:"略過",
    guide5:"完成",
    guide6:"繼續",
    watchTeaching:" 觀看教學",
    goPractice:"開始練習",
    goExamine:"開始小測",
    leave:"離開",
    leaveTitle:"你確定離開嗎？",
    leaveText:"離開後本次作答並不會儲存任何進度",
    start:"開始",
    skip:"跳過",
    previousQuestion:"上一題",
    nextQuestion:"下一題",
    finish:"完成",
    reset:"重置",
    cancel:"取消",
    confirm:"確定",
    submit:"提交",
    submitSuccess:"提交成功！",
    submitting:"提交中",
    submitTitle:"你確定提交嗎？",
    submitText1:"仍有題目未作答完畢。",
    questionNo: "題目編號:",
    question: "題",
    question2: "題",
    solutionApproach: "解答思路",
    answers: "參考答案",
    answers2: "查看答案",
    issue: "回報問題",
    finishAssessments: `恭喜你完成數學評估！`,
    finishWork: `恭喜你完成了作業！`,
    finishAdventure: `恭喜你完成了小測！`,
    finishLibrary: `恭喜你完成了練習！`,
    commend1: '加油！',
    commend2: '你很棒！',
    commend3: '還不錯！',
    commend4: '你答對了',
    small: "小",
    medium: "中",
    large: "大",
    issueText1: "必填",
    issueText2: "你發現了什麼問題?",
    issueText3: "回報問題",
    issueText4: "答案錯誤",
    issueText5: "發現錯字",
    issueText6: "錯位或者無法顯示",
    issueText7: "其它問題",
    issueText8: "描述問題",
    issueText9: "請提供你的電郵地址",
    rulesText1: "請輸入電郵地址",
    rulesText2: "請輸入正確的電郵地址",
    rulesText3: "請輸入描述問題",
    rulesText4: "請選择問題类型",
    practice1: "練習",
    coursesWitchingSuccessful: "課程切換成功",
    pleaseConductAnEvaluationFirst: "請先做評估",
    star:'星星',
    expire:'過期',
    active:'訂閱中',
    soon:'即将过期',
    end:'完結',
    assessmentTitle:'評估',
    assessmentText:'透過精心編排的測試題目，評估學生的數學能力，並進行智能分析，優先學習需加強的課題。',
    sys1:'歡迎首次登入學生平台！',
    sys2:'請選擇一位角色做你的頭像。',
    sys3:'學生平台教學',
    doHomeWork:'開始作業',
},
};
export default zh;
